<template>
  <div class="wg-smetrics">
    <div v-for="card in cards" :key="card.key + '-' + card.level" class="wg-smetric">
      <div class="stop">
        <div class="sn">{{ card.value }}</div>
        <button
          v-if="card.series && card.series.length > 1"
          type="button"
          class="wg-sparkbtn"
          title="Click to enlarge"
          @click="$emit('zoom', card)"
        >
          <wins-sparkline :data="card.series" dir="up" />
        </button>
      </div>
      <div class="sl">
        {{ card.label }}
        <wins-glossary-term :term="card.term" />
      </div>
      <div class="sd" :class="{ flat: card.flat }">
        <span v-if="!card.flat" class="tri">▲</span>
        {{ card.deltaText }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * The 3 metric boxes (design_updated9): no longer a fixed site trio - the
 * backend derives them from the top-ranked AI wins and freezes them into the
 * snapshot, so tab, email and PDF always agree. Wins-only surface: a card is
 * green or neutral, never red. Cards with a series get a sparkline that
 * zooms in a modal.
 */
import WinsGlossaryTerm from '@/components/SitesSingleView/WhiteGlove/Wins/WinsGlossaryTerm.vue'
import WinsSparkline from '@/components/SitesSingleView/WhiteGlove/Wins/WinsSparkline.vue'

export default {
  name: 'WinsMetricCards',
  components: { WinsGlossaryTerm, WinsSparkline },
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cards () {
      return this.report.cards || []
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../Settings/wg-tokens.scss';

/* simple metric cards - 3 up, bigger numbers */
.wg-smetrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
}

.wg-smetric {
  background: #fff;
  border: 1px solid $wg-panel-line;
  border-radius: 12px;
  padding: 22px 24px;

  .stop {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .sn {
    font-size: 2rem;
    font-weight: 800;
    color: $pop-teal;
    line-height: 1.1;
  }

  .sl {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 1rem;
    font-weight: 700;
    color: $pop-teal;
    margin-top: 6px;
  }

  .sd {
    font-size: 0.85rem;
    font-weight: 700;
    color: $pop-success;
    margin-top: 8px;

    &.flat {
      color: $pop-ink-faint;
    }

    .tri {
      font-size: 9px;
    }
  }
}

.wg-sparkbtn {
  border: none;
  background: none;
  padding: 2px;
  margin: -2px;
  cursor: zoom-in;
  border-radius: 6px;
  line-height: 0;

  &:hover {
    background: $pop-box-bg;
  }
}
</style>
